module.exports = __webpack_public_path__ + "img/tenant.237b72dc.svg";